var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMac = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9546 5.59901C11.8735 5.66502 10.3633 6.5231 10.3633 8.45379C10.3633 10.6815 12.2794 11.4736 12.3281 11.4901C12.3281 11.5396 12.0196 12.5627 11.3214 13.6188C10.6881 14.5429 10.0223 15.467 9.03178 15.467C8.04125 15.467 7.7652 14.8729 6.61229 14.8729C5.45938 14.8729 5.08591 15.5 4.16033 15.5C3.23476 15.5 2.60147 14.6419 1.87075 13.6023C1.01013 12.3647 0.328125 10.4505 0.328125 8.63531C0.328125 5.73102 2.19551 4.17987 4.03043 4.17987C5.00471 4.17987 5.81662 4.82343 6.43367 4.82343C7.01825 4.82343 7.91135 4.13036 9.03178 4.13036C9.45397 4.13036 10.9641 4.16337 11.9546 5.61551V5.59901ZM6.51486 3.94884C6.51486 3.94884 6.36872 3.94884 6.32001 3.93234C6.32001 3.89934 6.28753 3.78383 6.28753 3.66832C6.28753 2.89274 6.67725 2.11716 7.09944 1.63861C7.6353 0.99505 8.5284 0.533003 9.27535 0.5C9.29159 0.582508 9.30783 0.69802 9.30783 0.79703C9.30783 1.57261 8.98306 2.33168 8.5284 2.89274C8.04125 3.5033 7.19687 3.94884 6.5311 3.94884H6.51486Z",
    fill: "#101010"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMac);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mac.723c8383f94334668c45745ae48268ee.svg";